/**
 * API-Client fuer "Split rueckgaengig machen" - `GET`/`POST /api/jtl/orders/:kennung/split-rueckgaengig`
 * (`backend/src/http/routes/jtlSchreiben.ts`). Die Typen spiegeln `backend/src/domaene/splitRueckgaengig.ts`
 * und `splitEvents.ts`; das Frontend importiert kein Backend.
 */
import { anfrage } from "./basis.ts";

export interface RueckfuehrungsPlanZeile {
  art: "aendern" | "neu";
  kLieferantenBestellungPos: number | null;
  kArtikel: number;
  artikelNummer: string | null;
  mengeVorher: number;
  mengeZurueck: number;
  mengeNachher: number;
  ekNetto: number;
  mwst: number;
  lieferdatum: string | null;
}

export interface RueckfuehrungsDokument {
  linkId: string;
  docType: string;
  dateiname: string | null;
  waehlbar: boolean;
  grund: "schon_in_quelle" | "positionsbezogen" | "sendung" | "gruppe" | null;
  alsNeueFassung: boolean;
}

export interface RueckfuehrungsTask {
  id: string;
  titel: string;
  erledigt: boolean;
}

export interface RueckfuehrungsVorschau {
  kindNummer: string;
  quelleOrderId: string;
  quelleNummer: string;
  sperren: string[];
  offen: null | "geplant" | "aufgefuellt";
  /** Bei offener Rueckfuehrung die gespeicherte Auswahl des ersten Versuchs (die Fortsetzung nutzt sie). */
  gespeicherteAuswahl: RueckfuehrungsAuswahl | null;
  plan: RueckfuehrungsPlanZeile[];
  dokumente: RueckfuehrungsDokument[];
  tasks: RueckfuehrungsTask[];
}

export interface RueckfuehrungsAuswahl {
  dokumentIds: string[];
  taskIds: string[];
}

export interface RueckfuehrungsErgebnis {
  stand: string;
  fehler: string | null;
  quelleOrderId: string;
  /** Bestellnummer der Ursprungsbestellung ("" wenn unbekannt) - fuer die Erfolgsmeldung. */
  quelleNummer: string;
}

function pfad(kennung: number): string {
  return `/api/jtl/orders/${encodeURIComponent(String(kennung))}/split-rueckgaengig`;
}

export function rueckfuehrungsVorschauLaden(kennung: number): Promise<RueckfuehrungsVorschau> {
  return anfrage<RueckfuehrungsVorschau>(pfad(kennung), { methode: "GET" });
}

export function splitRueckgaengigAusfuehren(
  kennung: number,
  auswahl: RueckfuehrungsAuswahl,
): Promise<RueckfuehrungsErgebnis> {
  return anfrage<RueckfuehrungsErgebnis>(pfad(kennung), { methode: "POST", koerper: auswahl });
}
